// Import all images from assets directory
const imageModules = import.meta.glob('@/assets/*.{svg,png,jpg}', {eager: true});

export default class MapMarkerStorage {

    constructor() {
        // you can initialize any shared state here
    }

    getIconHtml(icon, divClassDefs = null, imgClassDefs = null) {
        return '<div class="' + (divClassDefs ? divClassDefs : '') + '"><i class="fas fa-'+icon+ (imgClassDefs ? (' '+imgClassDefs) : '')+'"><i/></div>'
    }

    getSvgIcon(svgFileName, height) {
        return '<div class="user-marker"><img src="'+svgFileName+'" style="height: '+height+'px; margin-top: -3px;"></img></div>'
    }

    getSvgPathIcon(divClassDefs, path) {
        return '<div class="' + (divClassDefs ? divClassDefs : '') + '">'+path+'</div>'
    }

    getImageIcon(fileName, alt, containerClass = null) {
        let result = '<div ' + (containerClass ? 'class="'+containerClass +'" ' : '') + '>'
        result += '<img src="'+fileName+'" style="width: 100%; height: 100%; object-fit: contain;" alt="' + alt + '">'
        result += '</div>'
        return result
    }

    getActiveTruckIcon() {
        return this.getIconHtml('truck-moving', 'vehicle-marker')
    }

    getInactiveTruckIcon() {
        return this.getIconHtml('truck-moving', 'vehicle-marker inactive')
    }

    getActiveCarIcon() {
        return this.getIconHtml('car-side', 'vehicle-marker')
    }

    getInactiveCarIcon() {
        return this.getIconHtml('car-side', 'vehicle-marker inactive')
    }
    getActiveMonsterIcon() {
        return this.getIconHtml('truck-monster', 'vehicle-marker')
    }
    getInactiveMonsterIcon() {
        return this.getIconHtml('truck-monster', 'vehicle-marker inactive')
    }
    getActiveTractorIcon() {
        return this.getIconHtml('tractor', 'vehicle-marker')
    }
    getInactiveTractorIcon() {
        return this.getIconHtml('tractor', 'vehicle-marker inactive')
    }
    getActiveSnowplowIcon() {
        return this.getIconHtml('snowplow', 'vehicle-marker')
    }
    getInactiveSnowplowIcon() {
        return this.getIconHtml('snowplow', 'vehicle-marker inactive')
    }
    getActiveHelicopterIcon() {
        return this.getIconHtml('helicopter', 'vehicle-marker inactive')
    }
    getInactiveHelicopterIcon() {
        return this.getIconHtml('helicopter', 'vehicle-marker inactive')
    }
    getActivePaverIcon() {
        return this.getIconHtml('snowplow', 'vehicle-marker')
    }
    getInactivePaverIcon() {
        return this.getIconHtml('snowplow', 'vehicle-marker inactive')
    }
    getActiveTrailerIcon() {
        return this.getIconHtml('trailer', 'vehicle-marker inactive')
    }
    getInactiveTrailerIcon() {
        return this.getIconHtml('trailer', 'vehicle-marker inactive')
    }
    getActiveDiggerIcon() {
        return this.getIconHtml('snowplow', 'vehicle-marker')
    }
    getInactiveDiggerIcon() {
        return this.getIconHtml('snowplow', 'vehicle-marker inactive')
    }
    getFenceIcon() {
        return this.getSvgIcon('../../assets/roadsign/I2.1_Sulkuaita.svg', 20)
    }
    getAbsorberIcon() {
        return this.getIconHtml('dolly-flatbed', 'vehicle-marker')
    }
    getActiveDefaultIcon() {
        return this.getIconHtml('cogs', 'vehicle-marker inactive')
    }
    getInactiveDefaultIcon() {
        return this.getIconHtml('cogs', 'vehicle-marker inactive')
    }
    getDefaultMarkerIcon() {
        return this.getIconHtml('map-marker', 'default-marker')
    }
    getUserMarkerIcon() {
        return '<div class="user-location"/>'
    }
    getEquipmentMarkerIcon() {
        return this.getImageIcon(this.getImageUrl('icon_equipment.png'))
    }
    getStorageMarkerGenericIcon() {
        return this.getIconHtml('warehouse', 'storage-marker')
    }
    getStorageMarkerAvailableIcon() {
        return this.getIconHtml('warehouse', 'storage-marker available')
    }
    getStorageMarkerOrderedIcon() {
        return this.getIconHtml('warehouse', 'storage-marker ordered')
    }
    getStorageMarkerOutOfStockIcon() {
        return this.getIconHtml('warehouse', 'storage-marker out-of-stock')
    }
    getStationMarkerIcon() {
        return this.getIconHtml('industry', 'station-marker')
    }
    getWeatherStationMarkerIcon() {
        return this.getIconHtml('cloud-sun', 'image-marker')
    }
    getHarjaNotificationMarkerIcon() {
        return this.getIconHtml('paint-brush', 'image-marker')
    }
    getDragAnchorMarkerIcon() {
        return this.getIconHtml('dot-circle', 'default-marker' )
    }
    getDragAnchorHeadMarkerIcon() {
        return this.getIconHtml('dot-circle', 'default-marker head-marker-color')
    }
    getObservationMarkerIcon() {
        return this.getSvgPathIcon('observation-marker', '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 384 512"><path fill="#fad62e" d="M384 192c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192z"/></svg>')
    }
    getPolylinePointIcon() {
        return this.getSvgPathIcon('observation-marker', '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 640 512"><path fill="#fad62e" d="M128 64c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 352 96 0 0-160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 160c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-352-96 0 0 160c0 17.7-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-160z"/></svg>')
    }
    getPolylinePointClosedIcon() {
        return this.getSvgPathIcon('observation-marker', '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 640 512"><path fill="#404040" d="M128 64c0-17.7 14.3-32 32-32l160 0c17.7 0 32 14.3 32 32l0 352 96 0 0-160c0-17.7 14.3-32 32-32l128 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-96 0 0 160c0 17.7-14.3 32-32 32l-160 0c-17.7 0-32-14.3-32-32l0-352-96 0 0 160c0 17.7-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l96 0 0-160z"/></svg>')
    }
    getPersonMarkerIcon() {
        return this.getIconHtml('user', 'user-marker')
    }
    getInactivePersonMarkerIcon() {
        return this.getIconHtml('user', 'user-marker inactive')
    }
    getAlertMarkerIcon() {
        return this.getIconHtml('exclamation', 'alert-marker' )
    }
    getCulvertIcon() {
        return this.getImageIcon(this.getImageUrl('icon_culvert.png'), 'Culvert', 'image-marker')
    }
    getDrainIcon() {
        return this.getImageIcon(this.getImageUrl('icon_drain.png'), 'Drain', 'image-marker round-marker')
    }
    getDrainDefectIcon() {
        return this.getImageIcon(this.getImageUrl('icon_drain_defect.png'), 'Drains', 'image-marker round-marker')
    }
    getPowerStationIcon(mode) {
        switch (mode) {
            case 1: return this.getImageIcon(this.getImageUrl('power_center_control.png'), 'Power')
            case 2: return this.getImageIcon(this.getImageUrl('power_center_clock.png'), 'Power')
            case 3: return this.getImageIcon(this.getImageUrl('power_center_dim.png'), 'Power')
        }
        return this.getImageIcon(this.getImageUrl('power_center.png'), 'Power')
    }
    getCableIcon(type) {
        switch (type){
            case 42: return '<div class="image-marker transparent-bg" style="color: #4af8f2"><font-awesome-icon icon="minus" /></div>'
            case 43: return '<div class="image-marker transparent-bg" style="color: rgba(96,59,51,0.71)"><font-awesome-icon icon="minus" /></div>'
            case 44: return '<div class="image-marker transparent-bg" style="color: #224462"><font-awesome-icon icon="minus" /></div>'
            case 45: return '<div class="image-marker transparent-bg" style="color: #888787"><font-awesome-icon icon="minus" /></div>'
        }
        return '<div class="image-marker transparent-bg" style="color: #404041"><font-awesome-icon icon="minus" /></div>'
    }
    getStreetLightIcon() {
        return this.getImageIcon(this.getImageUrl('street_light.png'), 'Light')
    }
    getStreetLightDefectIcon() {
        return this.getImageIcon(this.getImageUrl('street_light_defect.png'), 'Light')
    }
    getStreetLightPlannedIcon() {
        return this.getImageIcon(this.getImageUrl('street_light_planned.png'), 'Light')
    }
    getStreetLightRemovedIcon() {
        return this.getImageIcon(this.getImageUrl('street_light_removed.png'), 'Light')
    }
    getWasteBinGeneralIcon() {
        const mapIconName = 'bin-blue'
        let svgUrl = null
        for (const [path, module] of Object.entries(imageModules)) {
            if (path.includes(mapIconName)) {
                svgUrl = module.default || module
                break
            }
        }
        return this.getSvgMarker(svgUrl, null, null, '2.7em', '2.7em');
    }
    getWorkAssignmentMarkerIcon(open = false) {
        return open ?  this.getIconHtml('tasks','image-marker open-marker') :
            this.getIconHtml('tasks','image-marker')
    }
    getClosedWorkAssignmentMarkerIcon() {
        return this.getIconHtml('tasks', 'image-marker inactive-marker')
    }
    getMeasureDistanceMarkerIcon() {
        return '<div class="default-marker-leaflet" :style="{ color: #000000, marginTop: -3px}"><i class="fas fa-dot-circle"/></div>'
    }
    getCircleIcon() {
        return '<div :style="{ color: #000000}"><i class="fas fa-dot-circle"/></div>'
    }
    getSolidCircleIcon() {
        return '<div :style="{ color: \'#c50505\' }"><i class="fas fa-circle"/></div>'
    }
    getNeutralCircleIcon() {
        return '<div :style="{ color: \'#85e7db\' }"><i class="fas fa-circle"/></div>'
    }
    getPostIcon() {
        return this.getImageIcon(this.getImageUrl('icon_post.png'), 'Icon')
    }
    getPortalIcon() {
        return this.getImageIcon(this.getImageUrl('icon_portal.png'), 'Icon')
    }
    getStairsIcon() {
        return this.getImageIcon(this.getImageUrl('icon_stairs.png'), 'Icon', 'image-marker')
    }
    getGateIcon() {
        return this.getImageIcon(this.getImageUrl('icon_gate.png'), 'Icon', 'image-marker')
    }
    getEdgePileIcon() {
        return this.getImageIcon(this.getImageUrl('icon_edge_pile.png'), 'Icon')
    }
    getBoomIcon() {
        return this.getImageIcon(this.getImageUrl('icon_boom.png'), 'Icon')
    }
    getEquipmentIcon() {
        return this.getImageIcon(this.getImageUrl('icon_equipment.png'), 'Icon', 'image-marker')
    }
    getRoadAdIcon() {
        return this.getImageIcon(this.getImageUrl('icon_road_ad.png'), 'Icon')
    }
    getSimpleEquipmentIcon() {
        return '<div style="color: #32359d;"><i class="fas fa-flag" /></div>'
    }
    getAsDivElement(iconElement) {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = iconElement;
        return tempDiv.querySelector('div')
    }
    setIconStyleProperty(iconDiv, property, value) {
        iconDiv.style[property] = value;
    }
    getSvgMarker(svgPath, grayscale = false, text = null, width = '2em', height = '2em') {
        let result = '<div style="position: relative; display: inline-block; margin: 0; padding: 0; width: '+width+'; height: '+height+'">'
        result += '<img src="'+svgPath+'" style="width: 100%; height: 100%; object-fit: contain;'+ (grayscale ? ' filter: grayscale(100%) ' : '' )+ '" alt="n/a">'
        if (text) {
            result += '<span style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #000000; font-size: .8em; font-weight: bold;  text-align: center;">'+ text +'</span>'
        }
        result += '</div>'
        return result
    }
    getImageUrl(fileName) {
        try {
            // Find the matching module
            for (const [path, module] of Object.entries(imageModules)) {
                if (path.includes(fileName)) {
                    return module.default || module;
                }
            }

            console.warn('Image not found:', fileName);
            return ''; // or a fallback image path
        } catch (e) {
            console.warn('Image not found:', fileName, e);
            return ''; // or a fallback image path
        }
    }
}
